import { jsx as _jsx } from "react/jsx-runtime";
import { ComparisonFeatureItem } from '@as/cotopaxi';
import { useMemo } from 'react';
import { GLOSSARY_KEY } from '../../../constants/GeneralConstants';
export const CompareFeatureItem = ({ feature, isGlossaryLoaded, shouldInitGlossaryTooltip, setSwiperInstance, }) => {
    const glossaryId = `feature-item-${feature.title}`;
    const getGlossaryItem = (title, isLoaded) => { var _a; return isLoaded ? (_a = window[GLOSSARY_KEY]) === null || _a === void 0 ? void 0 : _a.find((glossary) => glossary.triggers.includes(title)) : undefined; };
    const glossaryItem = useMemo(() => getGlossaryItem(feature.title, isGlossaryLoaded), [feature, isGlossaryLoaded, shouldInitGlossaryTooltip]);
    const _setSwiperInstance = (swiper) => setSwiperInstance(swiper, feature.attribute);
    return (_jsx(ComparisonFeatureItem, { title: feature.title, values: feature.valuesByProducts, glossaryId: glossaryId, showGlossary: !!glossaryItem, setSwiperInstance: _setSwiperInstance }));
};
